import RouteError from '@/components/layout/Page/RouteError.vue';
import RouteLoading from '@/components/layout/Page/RouteLoading.vue';

export default [
  {
    path: 'view',
    name: 'view',
    component: () => import(/* webpackChunkName: "view-section" */'@/components/pages/view/View.vue'),
    meta: { title: 'View' },
  },
].map((route) => ({
  ...route,
  loading: RouteLoading,
  error: RouteError,
  delay: 200, // Delay before showing the loading component
  timeout: 5000, // The error component will be displayed if a timeout is provided and exceeded
  meta: {
    ...route.meta,
    section: 'View',
  },
}));
